module.exports = {
  "loading-container": {
    "position": "relative",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "loading-need-mask": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0,
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "dof-loading": {
    "zIndex": 9999
  },
  "loading-box": {
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "26",
    "paddingLeft": "50",
    "paddingRight": "50",
    "height": "160",
    "backgroundColor": "rgba(0,0,0,0.8)",
    "boxShadow": "0 0 4px 2px rgba(0, 0, 0, .1)"
  },
  "white-loading": {
    "backgroundColor": "rgba(255,255,255,0.9)",
    "boxShadow": "none"
  },
  "loading-image": {
    "height": "60",
    "width": "60"
  },
  "loadingTextBox": {
    "height": "176",
    "marginTop": "40",
    "marginBottom": "40"
  },
  "loadingMoreTextBox": {
    "height": "176",
    "paddingTop": "40",
    "paddingRight": "40",
    "paddingBottom": "40",
    "paddingLeft": "40",
    "flexWrap": "nowrap",
    "lines": 1
  },
  "loading-text": {
    "fontFamily": "PingFangSC-Regular",
    "color": "#E8E8E8",
    "fontSize": "24",
    "lineHeight": "24",
    "marginTop": "16",
    "textOverflow": "ellipsis",
    "textAlign": "center"
  },
  "blackText": {
    "color": "#1E2E37"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-4a53a9ce!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-loading/index.vue
// module id = 463
// module chunks = 0 1